import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import * as S from "./styled";
/**
 * Hooks
 */
import useLoading from '../../../../hooks/useLoading';
import apiRequest from "../../../../hooks/apiRequest";
/**
 * Components
 */
import LayoutModal from "../../../LayoutModal";
/**
 * Inteface
*/
import { Inputs } from "Interfaces/IAccessory";

interface ICreate {
  isOpenModalAcessory: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
}

export default function CreateAcessory({
  isOpenModalAcessory,
  setModalClose,
  refreshFrames,
}: ICreate) {
  const {
    register,
    control,
    reset,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest<Inputs>('accessory', 'POST', data);
      if (response.status === 201) {
        refreshFrames();
        onClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o usuário.");
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  }

  if (isOpenModalAcessory) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Acessório"
        subTitle="Cadastre um novo acessório em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}
      
        nameIconMinimize={'Registrar Acessório'}
      >
        <S.Container>
          <S.FormInput>
            <S.Label>
              Nome do Acessório
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Informe o nome"
              type="text"
              {...register("name", { required: true })}
            />
            {errors.name && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>Quantidade</S.Label>
              <S.Input
                placeholder="Informe a quantidade"
                type="number"
                {...register("amount", { required: true })}
              />
              {errors.amount && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.FormInput>
              <S.Label>Preço</S.Label>
              <Controller
                name="price"
                control={control}
                rules={{ required: 'Campo Obrigatório' }}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="R$ 0,00"
                    prefix="R$ "
                    value={value}
                    onValueChange={(values) => {
                      const purchaseValue = values.floatValue ?? 0;
                      onChange(purchaseValue); // Atualiza o valor de compra
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors.price && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>
          </S.SeparateDiv>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
